import { ClientConfig } from '../../config/ClientConfig'
import { getStore } from '../../redux/Store'
import { HttpService } from '../http-service'
import { Package, PackageContentItem, PackageContents, PackageModel } from './types'

export const PurchasePackageService = new class {
	async getPackages(): Promise<Package[]> {
		const bonusCodeValue = getStore().getState().purchase.bonusCode
		const bonusCodeQueryParameter = bonusCodeValue ? `?bonusCode=${bonusCodeValue}` : ''
		const url = `${ClientConfig.STORE_URL}/customers/packages${bonusCodeQueryParameter}`
		return HttpService.get<PackageModel[]>(url, { authenticate: true })
			.then(res => {
				return res.map(mapPackageFromModel)
			})
	}
}()

const mapPackageFromModel = (model: PackageModel): Package => {
	let mappedContents: PackageContentItem[] = model.contents
	if (model.contents.GOLD_COINS !== undefined) {
		// Old version of endpoint
		mappedContents = contentsMapToList(model.contents as PackageContents)
	}
	if (typeof model.expiresAt === 'string') {
		const expiresAtAsDate = new Date(model.expiresAt)
		model.expiresAt = { nanos: 0, seconds: (Math.floor(expiresAtAsDate.valueOf() / 1000))}
	}
	return {
		...model,
		contents: mappedContents,
	}
}

const contentsMapToList = (contentsMap: PackageContents): PackageContentItem[] => {
	const list = [{
		type: 'GOLD_COINS',
		amount: contentsMap.GOLD_COINS,
	}]
	if (contentsMap.SWEEPS_COINS) {
		list.push({
			type: 'SWEEPS_COINS',
			amount: contentsMap.SWEEPS_COINS,
		})
	}
	return list as PackageContentItem[]
}
